import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_ITINERARY_SUPPLIER_FOOD,
  CLEAR_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE,
  CLEAR_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT,
  CLEAR_ITINERARY_SUPPLIER_FOOD_REPORT,
  CLEAR_ITINERARY_SUPPLIER_FOOD_REPORT_DETAIL,
  CLEAR_ITINERARY_SUPPLIER_FOODS,
  FLAG_GETTING_ITINERARY_SUPPLIER_FOOD_REPORT,
  FLAG_ITINERARY_SUPPLIER_FOOD_ACTIVITY,
  FLAG_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE,
  FLAG_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT,
  FLAG_ITINERARY_SUPPLIER_FOODS,
  GET_ITINERARY_SUPPLIER_FOOD,
  GET_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE,
  GET_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT,
  GET_ITINERARY_SUPPLIER_FOOD_REPORT,
  GET_ITINERARY_SUPPLIER_FOOD_REPORT_DETAIL,
  GET_ITINERARY_SUPPLIER_FOODS,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  assignmentService: Immutable.Map({
    content: Immutable.List(),
    current: Immutable.Map({
      content: Immutable.Map(),
      activity: Immutable.List(),
    }),
    loading: false,
  }),
  report: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    detail: Immutable.Map(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_ITINERARY_SUPPLIER_FOODS:
      return state.setIn(['all', 'loading'], payload);
    case GET_ITINERARY_SUPPLIER_FOODS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_ITINERARY_SUPPLIER_FOODS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_ITINERARY_SUPPLIER_FOOD_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_ITINERARY_SUPPLIER_FOOD:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_ITINERARY_SUPPLIER_FOOD:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case GET_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE:
      return state.setIn(
        ['assignmentService', 'content'],
        Immutable.List(payload || []),
      );
    case CLEAR_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE:
      return state.setIn(
        ['assignmentService'],
        INITIAL_STATE.getIn(['assignmentService']),
      );
    case FLAG_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE:
      return state.setIn(['assignmentService', 'loading'], payload);
    case FLAG_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT:
      if (payload) {
        return state.setIn(
          ['assignmentService', 'current', 'activity'],
          state
            .getIn(['assignmentService', 'current', 'activity'])
            .push(payload),
        );
      }

      return state.setIn(
        ['assignmentService', 'current', 'activity'],
        state.getIn(['assignmentService', 'current', 'activity']).pop(),
      );
    case GET_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT:
      return state.setIn(
        ['assignmentService', 'current', 'content'],
        Immutable.Map(payload),
      );
    case CLEAR_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT:
      return state.setIn(
        ['assignmentService', 'current', 'content'],
        INITIAL_STATE.getIn(['assignmentService', 'current', 'content']),
      );
    case FLAG_GETTING_ITINERARY_SUPPLIER_FOOD_REPORT:
      return state.setIn(['report', 'loading'], payload);
    case GET_ITINERARY_SUPPLIER_FOOD_REPORT:
      return state.setIn(['report', 'content'], Immutable.Map(payload || []));
    case CLEAR_ITINERARY_SUPPLIER_FOOD_REPORT:
      return state.setIn(
        ['report', 'content'],
        INITIAL_STATE.getIn(['report', 'content']),
      );
    case GET_ITINERARY_SUPPLIER_FOOD_REPORT_DETAIL:
      return state.setIn(['report', 'detail'], Immutable.Map(payload));
    case CLEAR_ITINERARY_SUPPLIER_FOOD_REPORT_DETAIL:
      return state.setIn(
        ['report', 'detail'],
        INITIAL_STATE.getIn(['report', 'detail']),
      );
    default:
      return state;
  }
};
